import React, { useState } from "react";
import {
  RiFacebookBoxFill,
  RiPhoneFill,
  RiMailFill,
} from "react-icons/ri";
import ReactMarkdown from "react-markdown";
import FooterModal from "../../components/footermodel/FooterModal";
import termsMd from "../../assets/Document/TermCondition.md";
import privacyMd from "../../assets/Document/PrivacyPolicy.md";
import logo from "../../assets/LogoSalesSprc.png";
import "./footer.css";

const DOCUMENTS = {
  terms: { title: "Terms & Conditions", file: termsMd },
  privacy: { title: "Privacy Policy", file: privacyMd },
};

const SOCIALS = [
  {
    key: "facebook",
    href: "https://www.facebook.com/profile.php?id=61574923051551",
    Icon: RiFacebookBoxFill,
    label: "SALES on Facebook",
  },
  {
    key: "phone",
    href: "tel:01536243460",
    Icon: RiPhoneFill,
    label: "Call SALES",
  },
  {
    key: "email",
    href: "mailto:salesbarishal1988@gmail.com",
    Icon: RiMailFill,
    label: "Email SALES",
  },
];

const Footer = () => {
  const [modal, setModal] = useState({ show: false, title: "", content: "" });
  const [loadingDoc, setLoadingDoc] = useState(null);

  const openDocument = async (key) => {
    const doc = DOCUMENTS[key];
    if (!doc) return;
    setLoadingDoc(key);
    try {
      const response = await fetch(doc.file);
      const content = await response.text();
      setModal({ show: true, title: doc.title, content });
    } catch {
      setModal({
        show: true,
        title: doc.title,
        content:
          "This document could not be loaded. Please email salesbarishal1988@gmail.com and we will send you a copy.",
      });
    }
    setLoadingDoc(null);
  };

  return (
    <footer className="sales-footer on-dark">
      <div className="shell sales-footer__inner">
        <div className="sales-footer__brand">
          <img src={logo} alt="" width={54} height={54} aria-hidden="true" />
          <p className="sales-footer__name">SALES</p>
          <p className="sales-footer__full">
            Social Advancement for Livelihood and Educational Support
          </p>
          <address className="sales-footer__address">
            Holding 121, Ambagan Club Goli,
            <br />
            Police Line Road, Barishal, Bangladesh
          </address>
        </div>

        <nav className="sales-footer__col" aria-label="Site sections">
          <h2 className="sales-footer__heading">On this site</h2>
          <ul>
            <li><a href="/#whatsprc">About us</a></li>
            <li><a href="/#features">Our work</a></li>
            <li><a href="/#blog">Stories</a></li>
            <li><a href="/#possibility">Donate</a></li>
          </ul>
        </nav>

        <div className="sales-footer__col">
          <h2 className="sales-footer__heading">Organisation</h2>
          <ul>
            <li>
              <button
                type="button"
                onClick={() => openDocument("terms")}
                disabled={loadingDoc === "terms"}
              >
                Terms &amp; conditions
              </button>
            </li>
            <li>
              <button
                type="button"
                onClick={() => openDocument("privacy")}
                disabled={loadingDoc === "privacy"}
              >
                Privacy policy
              </button>
            </li>
            <li><a href="/admin">Admin</a></li>
          </ul>
        </div>

        <div className="sales-footer__col sales-footer__contact">
          <h2 className="sales-footer__heading">Contact</h2>
          <ul>
            <li>
              <a href="tel:01536243460">
                <RiPhoneFill size={16} aria-hidden="true" />
                01536 243460
              </a>
            </li>
            <li>
              <a href="mailto:salesbarishal1988@gmail.com">
                <RiMailFill size={16} aria-hidden="true" />
                salesbarishal1988@gmail.com
              </a>
            </li>
          </ul>
          <div className="sales-footer__socials">
            {SOCIALS.map(({ key, href, Icon, label }) => (
              <a
                key={key}
                href={href}
                aria-label={label}
                target={href.startsWith("http") ? "_blank" : undefined}
                rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
              >
                <Icon size={19} aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="shell sales-footer__bottom">
        <p>© {new Date().getFullYear()} SALES. All rights reserved.</p>
        <p>Barishal, Bangladesh</p>
      </div>

      <FooterModal
        show={modal.show}
        onHide={() => setModal({ show: false, title: "", content: "" })}
        title={modal.title}
      >
        <div className="doc-prose">
          <ReactMarkdown>{modal.content}</ReactMarkdown>
        </div>
      </FooterModal>
    </footer>
  );
};

export default Footer;
